import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Observable } from 'rxjs';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';

@Injectable()
export class LogoutRouteGuard implements CanActivate {

    constructor(
        private currentUserStateService: CurrentUserStateService) {
    }

    canActivate(): Observable<boolean> {
        return this.currentUserStateService.logout('LogoutGuard');
    }
}
